export default "/build/images/030-3.png?89d08ed779140f9c3b13825f7ec75c61";